import React, { Component } from 'react';
import { Col, Container, Form, FormGroup, Label, Input, Row } from 'reactstrap';
import Api from './Api';
import TeamInvitationsTable from './TeamInvitationsTable';
import './TeamPanel.css';

class TeamPanel extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {};
  }

  componentDidMount() {
    this.fetchInvitations();
  }

  fetchInvitations() {
    Api.teamGetInvitations()
      .then(result => {
        if (!result || result.error) {
          this.setState({error: result.error});
          return;
        }
        this.setState({
          error: null,
          invitations: result.invitations,
        });
      });
  }

  updateGuestNameQuery = (e) => {
    this.setState({
      guestNameQuery: e.target.value,
    });
  }

  moveInvitation = (idx, offset) => {
    const invitations = this.state.invitations;
    const invitation = invitations.splice(idx, 1)[0];
    invitations.splice(idx + offset, 0, invitation);
    const ids = [];
    for (var i = 0; i < invitations.length; i++) {
      ids.push(invitations[i].invitation_id);
    }
    this.setState({ invitations: invitations  });
    Api.teamUpdateInvitationsOrder(ids);
  }

  moveGuest = (invitationIdx, guestIdx, offset) => {
    const invitation = this.state.invitations[invitationIdx];
    const guests = invitation.guests;
    const guest = guests.splice(guestIdx, 1)[0];
    guests.splice(guestIdx + offset, 0, guest);
    const guestIds = [];
    for (var i = 0; i < guests.length; i++) {
      guestIds.push(guests[i].guest_id);
    }
    this.setState({ invitations: this.state.invitations  });
    Api.teamUpdateInvitationGuestsOrder(invitation.invitation_id, guestIds);
  }

  render() {
    const error = this.state.error ? (
      <p className="error">{this.state.error}</p>
    ) : null;

    var invitations = this.state.invitations;
    if (this.state.guestNameQuery) {
      const query = this.state.guestNameQuery.toLowerCase();
      invitations = invitations.filter(i => (
        i.name.toLowerCase().indexOf(query) >= 0
        || i.guests.find(g => (
          (g.first_name && g.first_name.toLowerCase().indexOf(query) >= 0)
          || (g.last_name && g.last_name.toLowerCase().indexOf(query) >= 0)
      ))));
    }
    
    return (
      <Container id="team-panel">
        <Row>
          <Col>
            <h1>Team Panel</h1>
          </Col>
        </Row>
        <Form>
          <FormGroup row>
            <Col>
              <Label for="guest_search_query" hidden>Search for guest:</Label>
              <Input type="text" id="guest_search_query" placeholder="Search guest name" onChange={this.updateGuestNameQuery}/>
            </Col>
          </FormGroup>
        </Form>
        <Row>
          <Col>
            {error}
          </Col>
        </Row>
        <TeamInvitationsTable
          invitations={invitations}
          onMoveInvitation={this.moveInvitation}
          onMoveGuest={this.moveGuest}
        />
      </Container>
    );
  }
}

export default TeamPanel;



// WEBPACK FOOTER //
// ./src/TeamPanel.js